import { DropdownSelectOption } from '../components/DropdownSelect/DropdownSelect';

export const bankOptions: DropdownSelectOption[] = [
  { value: 'Axis Bank Limited', label: 'Axis Bank Limited' },
  { value: 'Bandhan Bank Limited', label: 'Bandhan Bank Limited' },
  { value: 'CSB Bank Limited', label: 'CSB Bank Limited' },
  { value: 'City Union Bank Limited', label: 'City Union Bank Limited' },
  { value: 'DCB Bank Limited', label: 'DCB Bank Limited' },
  { value: 'Dhanlaxmi Bank Limited', label: 'Dhanlaxmi Bank Limited' },
  { value: 'Federal Bank Limited', label: 'Federal Bank Limited' },
  {
    value: 'GS Mahanagar Co-Operative Bank Ltd',
    label: 'GS Mahanagar Co-Operative Bank Ltd'
  },
  { value: 'HDFC Bank Limited', label: 'HDFC Bank Limited' },
  { value: 'ICICI Bank Limited', label: 'ICICI Bank Limited' },
  { value: 'IndusInd Bank Limited', label: 'IndusInd Bank Limited' },
  { value: 'IDFC FIRST Bank Limited', label: 'IDFC FIRST Bank Limited' },
  {
    value: 'Jammu & Kashmir Bank Limited',
    label: 'Jammu & Kashmir Bank Limited'
  },
  { value: 'Karnataka Bank Limited', label: 'Karnataka Bank Limited' },
  { value: 'Karur Vysya Bank Limited', label: 'Karur Vysya Bank Limited' },
  {
    value: 'Kotak Mahindra Bank Limited',
    label: 'Kotak Mahindra Bank Limited'
  },
  { value: 'Nainital bank Limited', label: 'Nainital bank Limited' },
  { value: 'RBL Bank Limited', label: 'RBL Bank Limited' },
  { value: 'South Indian Bank Limited', label: 'South Indian Bank Limited' },
  {
    value: 'Tamilnad Mercantile Bank Limited',
    label: 'Tamilnad Mercantile Bank Limited'
  },
  { value: 'YES Bank Limited', label: 'YES Bank Limited' },
  { value: 'IDBI Bank Limited', label: 'IDBI Bank Limited' },
  {
    value: 'Mangal Co-Operative Bank Ltd',
    label: 'Mangal Co-Operative Bank Ltd'
  },
  {
    value: 'Mumbai District Central Co-operative Bank Ltd',
    label: 'Mumbai District Central Co-operative Bank Ltd'
  },
  {
    value: 'Kokan Mercantile Cooperative Bank',
    label: 'Kokan Mercantile Cooperative Bank'
  },
  {
    value: 'The Malad Sahakari Bank Ltd',
    label: 'The Malad Sahakari Bank Ltd'
  },
  {
    value: 'Coastal Local Area Bank Limited',
    label: 'Coastal Local Area Bank Limited'
  },
  {
    value: 'Krishna Bhima Samruddhi LAB Limited',
    label: 'Krishna Bhima Samruddhi LAB Limited'
  },
  {
    value: 'Subhadra Local Bank Limited',
    label: 'Subhadra Local Bank Limited'
  },
  {
    value: 'Au Small Finance Bank Limited',
    label: 'Au Small Finance Bank Limited'
  },
  {
    value: 'Capital Small Finance Bank Limited',
    label: 'Capital Small Finance Bank Limited'
  },
  {
    value: 'Fincare Small Finance Bank Limited',
    label: 'Fincare Small Finance Bank Limited'
  },
  {
    value: 'Equitas Small Finance Bank Limited',
    label: 'Equitas Small Finance Bank Limited'
  },
  {
    value: 'ESAF Small Finance Bank Limited',
    label: 'ESAF Small Finance Bank Limited'
  },
  {
    value: 'Suryoday Small Finance Bank Limited',
    label: 'Suryoday Small Finance Bank Limited'
  },
  {
    value: 'Ujjivan Small Finance Bank Limited',
    label: 'Ujjivan Small Finance Bank Limited'
  },
  {
    value: 'Utkarsh Small Finance Bank Limited',
    label: 'Utkarsh Small Finance Bank Limited'
  },
  {
    value: 'North East Small finance Bank Limited',
    label: 'North East Small finance Bank Limited'
  },
  {
    value: 'Jana Small Finance Bank Limited',
    label: 'Jana Small Finance Bank Limited'
  },
  {
    value: 'Shivalik Small Finance Bank Limited',
    label: 'Shivalik Small Finance Bank Limited'
  },
  {
    value: 'Unity Small Finance Bank Limited',
    label: 'Unity Small Finance Bank Limited'
  },
  {
    value: 'Airtel Payments Bank Limited',
    label: 'Airtel Payments Bank Limited'
  },
  {
    value: 'India Post Payments Bank Limited',
    label: 'India Post Payments Bank Limited'
  },
  {
    value: 'FINO Payments Bank Limited',
    label: 'FINO Payments Bank Limited'
  },
  {
    value: 'Paytm Payments Bank Limited',
    label: 'Paytm Payments Bank Limited'
  },
  { value: 'Jio Payments Bank Limited', label: 'Jio Payments Bank Limited' },
  {
    value: 'NSDL Payments Bank Limited',
    label: 'NSDL Payments Bank Limited'
  },
  { value: 'Bank of Baroda', label: 'Bank of Baroda' },
  { value: 'Bank of India', label: 'Bank of India' },
  { value: 'Bank of Maharashtra', label: 'Bank of Maharashtra' },
  { value: 'Canara Bank', label: 'Canara Bank' },
  { value: 'Central Bank of India', label: 'Central Bank of India' },
  { value: 'Indian Bank', label: 'Indian Bank' },
  { value: 'Indian Overseas Bank', label: 'Indian Overseas Bank' },
  { value: 'Punjab & Sind Bank', label: 'Punjab & Sind Bank' },
  { value: 'Punjab National Bank', label: 'Punjab National Bank' },
  { value: 'State Bank of India', label: 'State Bank of India' },
  { value: 'UCO Bank', label: 'UCO Bank' },
  { value: 'Union Bank of India', label: 'Union Bank of India' },
  {
    value: 'National Bank for Agriculture and Rural Development',
    label: 'National Bank for Agriculture and Rural Development'
  },
  {
    value: 'Export-Import Bank of India',
    label: 'Export-Import Bank of India'
  },
  { value: 'National Housing Bank', label: 'National Housing Bank' },
  {
    value: 'Small Industries Development Bank of India',
    label: 'Small Industries Development Bank of India'
  },
  {
    value: 'Siddheshwar Urban Co-op Bank',
    label: 'Siddheshwar Urban Co-op Bank'
  },
  { value: 'AB Bank Limited', label: 'AB Bank Limited' },
  {
    value: 'Abu Dhabi Commercial Bank Limited',
    label: 'Abu Dhabi Commercial Bank Limited'
  },
  {
    value: 'American Express Banking Corp.',
    label: 'American Express Banking Corp.'
  },
  {
    value: 'Australia and New Zealand Banking Group Limited',
    label: 'Australia and New Zealand Banking Group Limited'
  },
  { value: 'Bank of America', label: 'Bank of America' },
  {
    value: 'Bank of Bahrain & Kuwait BSC',
    label: 'Bank of Bahrain & Kuwait BSC'
  },
  { value: 'Bank of Ceylon', label: 'Bank of Ceylon' },
  { value: 'Bank of China', label: 'Bank of China' },
  { value: 'Bank of Nova Scotia', label: 'Bank of Nova Scotia' },
  { value: 'Barclays Bank Plc.', label: 'Barclays Bank Plc.' },
  { value: 'BNP Paribas', label: 'BNP Paribas' },
  { value: 'Citibank N.A.', label: 'Citibank N.A.' },
  {
    value: 'Cooperatieve Rabobank U.A.',
    label: 'Cooperatieve Rabobank U.A.'
  },
  {
    value: 'Credit Agricole Corporate & Investment Bank',
    label: 'Credit Agricole Corporate & Investment Bank'
  },
  { value: 'Credit Suisse A.G', label: 'Credit Suisse A.G' },
  { value: 'CTBC Bank Co., Limited', label: 'CTBC Bank Co., Limited' },
  { value: 'DBS Bank Limited', label: 'DBS Bank Limited' },
  { value: 'Deutsche Bank', label: 'Deutsche Bank' },
  { value: 'Doha Bank', label: 'Doha Bank' },
  { value: 'Emirates NBD Bank PJSC', label: 'Emirates NBD Bank PJSC' },
  { value: 'First Abu Dhabi Bank PJSC', label: 'First Abu Dhabi Bank PJSC' },
  { value: 'FirstRand Bank Limited', label: 'FirstRand Bank Limited' },
  { value: 'HSBC Limited', label: 'HSBC Limited' },
  {
    value: 'Industrial & Commercial Bank of China Limited',
    label: 'Industrial & Commercial Bank of China Limited'
  },
  { value: 'Industrial Bank of Korea', label: 'Industrial Bank of Korea' },
  {
    value: 'J.P. Morgan Chase Bank N.A.',
    label: 'J.P. Morgan Chase Bank N.A.'
  },
  { value: 'JSC VTB Bank', label: 'JSC VTB Bank' },
  { value: 'KEB Hana Bank', label: 'KEB Hana Bank' },
  {
    value: 'Krung Thai Bank Public Co. Limited',
    label: 'Krung Thai Bank Public Co. Limited'
  },
  { value: 'Mashreq Bank PSC', label: 'Mashreq Bank PSC' },
  { value: 'Mizuho Bank Limited', label: 'Mizuho Bank Limited' },
  { value: 'MUFG Bank, Limited', label: 'MUFG Bank, Limited' },
  { value: 'National Australia Bank', label: 'National Australia Bank' },
  { value: 'NatWest Markets plc', label: 'NatWest Markets plc' },
  {
    value: 'PT Bank Maybank Indonesia TBK',
    label: 'PT Bank Maybank Indonesia TBK'
  },
  { value: 'Qatar National Bank SAQ', label: 'Qatar National Bank SAQ' },
  { value: 'Sberbank', label: 'Sberbank' },
  { value: 'Shinhan Bank', label: 'Shinhan Bank' },
  { value: 'Societe Generale', label: 'Societe Generale' },
  { value: 'Sonali Bank Limited', label: 'Sonali Bank Limited' },
  { value: 'Standard Chartered Bank', label: 'Standard Chartered Bank' },
  { value: 'State Bank of Mauritius', label: 'State Bank of Mauritius' },
  {
    value: 'Sumitomo Mitsui Banking Corporation',
    label: 'Sumitomo Mitsui Banking Corporation'
  },
  {
    value: 'United Overseas Bank Limited',
    label: 'United Overseas Bank Limited'
  },
  {
    value: 'Westpac Banking Corporation',
    label: 'Westpac Banking Corporation'
  },
  { value: 'Woori Bank', label: 'Woori Bank' },
  {
    value: 'Abhyudaya Co-operative Bank Limited',
    label: 'Abhyudaya Co-operative Bank Limited'
  },
  {
    value: 'Ahmedabad Mercantile Co-Op Bank Limited',
    label: 'Ahmedabad Mercantile Co-Op Bank Limited'
  },
  {
    value: 'Amanath Co-operative Bank Limited',
    label: 'Amanath Co-operative Bank Limited'
  },
  {
    value: 'Andhra Pradesh Mahesh Co-Op Urban Bank Limited',
    label: 'Andhra Pradesh Mahesh Co-Op Urban Bank Limited'
  },
  {
    value: 'Bassein Catholic Co-operative Bank Limited',
    label: 'Bassein Catholic Co-operative Bank Limited'
  },
  {
    value: 'Bharat Co-operative Bank Mumbai Limited',
    label: 'Bharat Co-operative Bank Mumbai Limited'
  },
  {
    value: 'Bharati Sahakari Bank Limited',
    label: 'Bharati Sahakari Bank Limited'
  },
  {
    value: 'Bombay Mercantile Co-operative Bank Limited',
    label: 'Bombay Mercantile Co-operative Bank Limited'
  },
  {
    value: 'Charminar Co-operative Urban Bank Limited',
    label: 'Charminar Co-operative Urban Bank Limited'
  },
  {
    value: 'Citizen Credit Co-operative Bank Limited',
    label: 'Citizen Credit Co-operative Bank Limited'
  },
  {
    value: 'Cosmos Co-operative Urban Bank Limited',
    label: 'Cosmos Co-operative Urban Bank Limited'
  },
  {
    value: 'Dombivli Nagari Sahakari Bank Limited',
    label: 'Dombivli Nagari Sahakari Bank Limited'
  },
  {
    value: 'Goa Urban Co-operative Bank Limited',
    label: 'Goa Urban Co-operative Bank Limited'
  },
  {
    value: 'Gopinath Patil Parsik Janata Sahakari Bank Limited',
    label: 'Gopinath Patil Parsik Janata Sahakari Bank Limited'
  },
  {
    value: 'Greater Bombay Co-operative Bank Limited',
    label: 'Greater Bombay Co-operative Bank Limited'
  },
  {
    value: 'Indian Mercantile Co-operative Bank Limited',
    label: 'Indian Mercantile Co-operative Bank Limited'
  },
  {
    value: 'Jalgaon Janata Sahakari Bank Limited',
    label: 'Jalgaon Janata Sahakari Bank Limited'
  },
  {
    value: 'Janakalyan Sahakari Bank Limited',
    label: 'Janakalyan Sahakari Bank Limited'
  },
  {
    value: 'Janalaxmi Co-operative Bank Limited',
    label: 'Janalaxmi Co-operative Bank Limited'
  },
  {
    value: 'Janata Sahakari Bank Limited',
    label: 'Janata Sahakari Bank Limited'
  },
  {
    value: 'Jharkhand State Co-operative Bank Limited',
    label: 'Jharkhand State Co-operative Bank Limited'
  },
  {
    value: 'Kallappanna Awade Ichalkaranji Janata Sahakari Bank Limited',
    label: 'Kallappanna Awade Ichalkaranji Janata Sahakari Bank Limited'
  },
  {
    value: 'Kalupur Commercial Co-Op Bank Limited',
    label: 'Kalupur Commercial Co-Op Bank Limited'
  },
  {
    value: 'Kalyan Janata Sahakari Bank Limited',
    label: 'Kalyan Janata Sahakari Bank Limited'
  },
  {
    value: 'Karad Urban Co-operative Bank Limited',
    label: 'Karad Urban Co-operative Bank Limited'
  },
  {
    value: 'Madhavpura Mercantile Co-Op Bank Limited',
    label: 'Madhavpura Mercantile Co-Op Bank Limited'
  },
  {
    value: 'Mahanagar Co-operative Bank Limited',
    label: 'Mahanagar Co-operative Bank Limited'
  },
  {
    value: 'Mapusa Urban Co-operative Bank of Goa Limited',
    label: 'Mapusa Urban Co-operative Bank of Goa Limited'
  },
  {
    value: 'Mehsana Urban Co-Op Bank Limited',
    label: 'Mehsana Urban Co-Op Bank Limited'
  },
  {
    value: 'Nagar Urban Co-operative Bank Limited',
    label: 'Nagar Urban Co-operative Bank Limited'
  },
  {
    value: 'Nagpur Nagrik Sahakari Bank Limited',
    label: 'Nagpur Nagrik Sahakari Bank Limited'
  },
  {
    value: "Nasik Merchant's Co-operative Bank Limited",
    label: "Nasik Merchant's Co-operative Bank Limited"
  },
  {
    value: 'Nashik District Industrial & Mercantile Co-Op Bank Ltd Nashik',
    label: 'Nashik District Industrial & Mercantile Co-Op Bank Ltd Nashik'
  },
  {
    value: 'New India Co-operative Bank Limited',
    label: 'New India Co-operative Bank Limited'
  },
  {
    value: 'NKGSB Co-operative Bank Limited',
    label: 'NKGSB Co-operative Bank Limited'
  },
  {
    value: 'Nutan Nagarik Sahakari Bank Limited',
    label: 'Nutan Nagarik Sahakari Bank Limited'
  },
  {
    value: 'Omprakash Deora Peoples Co-Op Bank Ltd.',
    label: 'Omprakash Deora Peoples Co-Op Bank Ltd.'
  },
  {
    value: 'Pravara Sahakari Bank Limited',
    label: 'Pravara Sahakari Bank Limited'
  },
  {
    value: 'Punjab & Maharashtra Co-operative Bank Limited',
    label: 'Punjab & Maharashtra Co-operative Bank Limited'
  },
  {
    value: 'Raigad Sahakari Bank Limited',
    label: 'Raigad Sahakari Bank Limited'
  },
  {
    value: 'Rajkot Nagrik Sahakari Bank Limited',
    label: 'Rajkot Nagrik Sahakari Bank Limited'
  },
  {
    value: 'Rupee Co-operative Bank Limited',
    label: 'Rupee Co-operative Bank Limited'
  },
  {
    value: 'Sangli Urban Co-operative Bank Limited',
    label: 'Sangli Urban Co-operative Bank Limited'
  },
  {
    value: 'Saraswat Co-operative Bank Limited',
    label: 'Saraswat Co-operative Bank Limited'
  },
  {
    value: 'Sardar Bhiladwala Pardi Peoples Coop Bank Limited',
    label: 'Sardar Bhiladwala Pardi Peoples Coop Bank Limited'
  },
  {
    value: 'Shamrao Vithal Co-operative Bank Limited',
    label: 'Shamrao Vithal Co-operative Bank Limited'
  },
  {
    value: 'Shikshak Sahakari Bank Limited',
    label: 'Shikshak Sahakari Bank Limited'
  },
  {
    value: 'Solapur Janata Sahakari Bank Limited',
    label: 'Solapur Janata Sahakari Bank Limited'
  },
  {
    value: 'Surat Peoples Coop Bank Limited',
    label: 'Surat Peoples Coop Bank Limited'
  },
  {
    value: 'Thane Bharat Sahakari Bank Limited',
    label: 'Thane Bharat Sahakari Bank Limited'
  },
  {
    value: 'Thane Janata Sahakari Bank Limited',
    label: 'Thane Janata Sahakari Bank Limited'
  },
  {
    value: 'The Akola Janata Commercial Co-operative Bank Limited',
    label: 'The Akola Janata Commercial Co-operative Bank Limited'
  },
  {
    value: 'The Akola Urban Co-operative Bank Limited',
    label: 'The Akola Urban Co-operative Bank Limited'
  },
  { value: 'DMK JAOLI BANK', label: 'DMK JAOLI BANK' },
  {
    value: 'DECCAN MERCHANT CO-OPERATIVE BANK LTD',
    label: 'DECCAN MERCHANT CO-OPERATIVE BANK LTD'
  },
  {
    value: 'MOGAVEERA BANK CO-OPERATIVE BANK',
    label: 'MOGAVEERA BANK CO-OPERATIVE BANK'
  },
  { value: 'SAMATA SAHAKARI BANK LTD', label: 'SAMATA SAHAKARI BANK LTD' },
  {
    value: 'The Andaman and Nicobar State Co-operative Bank Limited',
    label: 'The Andaman and Nicobar State Co-operative Bank Limited'
  },
  {
    value: 'The Andhra Pradesh State Co-operative Bank Limited',
    label: 'The Andhra Pradesh State Co-operative Bank Limited'
  },
  {
    value: 'The Arunachal Pradesh State co-operative Apex Bank Limited',
    label: 'The Arunachal Pradesh State co-operative Apex Bank Limited'
  },
  {
    value: 'The Assam Co-operative Apex Bank Limited',
    label: 'The Assam Co-operative Apex Bank Limited'
  },
  {
    value: 'The Bihar State Co-operative Bank Limited',
    label: 'The Bihar State Co-operative Bank Limited'
  },
  {
    value: 'The Chandigarh State Co-operative Bank Limited',
    label: 'The Chandigarh State Co-operative Bank Limited'
  },
  {
    value: 'The Chhattisgarh Rajya Sahakari Bank',
    label: 'The Chhattisgarh Rajya Sahakari Bank'
  },
  {
    value: 'The Chhattisgarh RajyaSahakari Bank Maryadit',
    label: 'The Chhattisgarh RajyaSahakari Bank Maryadit'
  },
  {
    value: 'The Delhi State Co-operative Bank Limited',
    label: 'The Delhi State Co-operative Bank Limited'
  },
  {
    value: 'The Goa State Co-operative Bank Limited',
    label: 'The Goa State Co-operative Bank Limited'
  },
  {
    value: 'The Greater Bombay Co-operative Bank Ltd',
    label: 'The Greater Bombay Co-operative Bank Ltd'
  },
  {
    value: 'The Gujarat State Co-operative Bank Limited',
    label: 'The Gujarat State Co-operative Bank Limited'
  },
  {
    value: 'The Haryana State Co-opertive Apex Bank Limited',
    label: 'The Haryana State Co-opertive Apex Bank Limited'
  },
  {
    value: 'The Himachal Pradesh State Co-operative Bank Limited',
    label: 'The Himachal Pradesh State Co-operative Bank Limited'
  },
  {
    value: 'The Jammu and Kashmir State Co-operative Bank Limited',
    label: 'The Jammu and Kashmir State Co-operative Bank Limited'
  },
  {
    value: 'The Kapol Co-operative Bank Limited',
    label: 'The Kapol Co-operative Bank Limited'
  },
  {
    value: 'The Karnataka State Co-operative Apex Bank Limited',
    label: 'The Karnataka State Co-operative Apex Bank Limited'
  },
  {
    value: 'The Kerala State Co-operative Bank Limited',
    label: 'The Kerala State Co-operative Bank Limited'
  },
  {
    value: 'The Khamgaon Urban Co-operative Bank Limited',
    label: 'The Khamgaon Urban Co-operative Bank Limited'
  },
  {
    value: 'The Kurla Nagrik Sahakari Bank Ltd',
    label: 'The Kurla Nagrik Sahakari Bank Ltd'
  },
  {
    value: 'The Madhya Pradesh Rajya Sahakari Bank Maryadit',
    label: 'The Madhya Pradesh Rajya Sahakari Bank Maryadit'
  },
  {
    value: 'The Maharashtra State Co-operative Bank Limited',
    label: 'The Maharashtra State Co-operative Bank Limited'
  },
  {
    value: 'The Manipur State Co-operative Bank Limited',
    label: 'The Manipur State Co-operative Bank Limited'
  },
  {
    value: 'The Meghalaya Co-operative Apex Bank Limited',
    label: 'The Meghalaya Co-operative Apex Bank Limited'
  },
  {
    value: 'The Mizoram Co-operative Apex Bank Limited',
    label: 'The Mizoram Co-operative Apex Bank Limited'
  },
  {
    value: 'The Nagaland State Co-operative Bank Limited',
    label: 'The Nagaland State Co-operative Bank Limited'
  },
  {
    value: 'The Nashik Jilha Mahila Sahakari Bank Nashik',
    label: 'The Nashik Jilha Mahila Sahakari Bank Nashik'
  },
  {
    value: 'The Orissa State Co-operative Bank Limited',
    label: 'The Orissa State Co-operative Bank Limited'
  },
  {
    value: 'The Panipat Urban Co-operative Bank Limited',
    label: 'The Panipat Urban Co-operative Bank Limited'
  },
  {
    value: 'The Pondichery State Co-opertive Bank Limited',
    label: 'The Pondichery State Co-opertive Bank Limited'
  },
  {
    value: 'The Punjab State Co-operative Bank Limited',
    label: 'The Punjab State Co-operative Bank Limited'
  },
  {
    value: 'The Rajasthan State Co-operative Bank Limited',
    label: 'The Rajasthan State Co-operative Bank Limited'
  },
  {
    value: 'The Sikkim State Co-operative Bank Limited',
    label: 'The Sikkim State Co-operative Bank Limited'
  },
  {
    value: 'The Tamil Nadu State Apex Co-operative Bank Limited',
    label: 'The Tamil Nadu State Apex Co-operative Bank Limited'
  },
  {
    value: 'The Telangana State Cooperative Apex Bank Limited',
    label: 'The Telangana State Cooperative Apex Bank Limited'
  },
  {
    value: 'The Tripura State Co-operative Bank Limited',
    label: 'The Tripura State Co-operative Bank Limited'
  },
  {
    value: 'The Uttar Pradesh Co-operative Bank Limited',
    label: 'The Uttar Pradesh Co-operative Bank Limited'
  },
  {
    value: 'The Uttaranchal Rajya Sahakari Bank Limited',
    label: 'The Uttaranchal Rajya Sahakari Bank Limited'
  },
  {
    value: 'The West Bengal State Co-operative Bank Limited',
    label: 'The West Bengal State Co-operative Bank Limited'
  },
  {
    value: 'Vasavi Coop Urban Bank Limited',
    label: 'Vasavi Coop Urban Bank Limited'
  },
  {
    value: 'Vidyasagar Co-operative Bank Limited Midnapore',
    label: 'Vidyasagar Co-operative Bank Limited Midnapore'
  },
  {
    value: 'Zoroastrian Co-operative Bank Limited',
    label: 'Zoroastrian Co-operative Bank Limited'
  },
  { value: 'Assam Gramin Vikash Bank', label: 'Assam Gramin Vikash Bank' },
  {
    value: 'Andhra Pradesh Grameena Vikas Bank',
    label: 'Andhra Pradesh Grameena Vikas Bank'
  },
  {
    value: 'Andhra Pragathi Grameena Bank',
    label: 'Andhra Pragathi Grameena Bank'
  },
  {
    value: 'Arunachal Pradesh Rural Bank',
    label: 'Arunachal Pradesh Rural Bank'
  },
  { value: 'Aryavart Bank', label: 'Aryavart Bank' },
  {
    value: 'Bangiya Gramin Vikash Bank',
    label: 'Bangiya Gramin Vikash Bank'
  },
  {
    value: 'Baroda Gujarat Gramin Bank',
    label: 'Baroda Gujarat Gramin Bank'
  },
  {
    value: 'Baroda Rajasthan Kshetriya Gramin Bank',
    label: 'Baroda Rajasthan Kshetriya Gramin Bank'
  },
  { value: 'Baroda UP Bank', label: 'Baroda UP Bank' },
  { value: 'Chaitanya Godavari GB', label: 'Chaitanya Godavari GB' },
  {
    value: 'Chhattisgarh Rajya Gramin Bank',
    label: 'Chhattisgarh Rajya Gramin Bank'
  },
  { value: 'Dakshin Bihar Gramin Bank', label: 'Dakshin Bihar Gramin Bank' },
  { value: 'Ellaquai Dehati Bank', label: 'Ellaquai Dehati Bank' },
  {
    value: 'Himachal Pradesh Gramin Bank',
    label: 'Himachal Pradesh Gramin Bank'
  },
  { value: 'J&K Grameen Bank', label: 'J&K Grameen Bank' },
  {
    value: 'Jharkhand Rajya Gramin Bank',
    label: 'Jharkhand Rajya Gramin Bank'
  },
  { value: 'Karnataka Gramin Bank', label: 'Karnataka Gramin Bank' },
  {
    value: 'Karnataka Vikas Gramin Bank',
    label: 'Karnataka Vikas Gramin Bank'
  },
  { value: 'Kerala Gramin Bank', label: 'Kerala Gramin Bank' },
  {
    value: 'Madhya Pradesh Gramin Bank',
    label: 'Madhya Pradesh Gramin Bank'
  },
  { value: 'Madhyanchal Gramin Bank', label: 'Madhyanchal Gramin Bank' },
  { value: 'Maharashtra Gramin Bank', label: 'Maharashtra Gramin Bank' },
  { value: 'Manipur Rural Bank', label: 'Manipur Rural Bank' },
  { value: 'Meghalaya Rural Bank', label: 'Meghalaya Rural Bank' },
  { value: 'Mizoram Rural Bank', label: 'Mizoram Rural Bank' },
  { value: 'Nagaland Rural Bank', label: 'Nagaland Rural Bank' },
  { value: 'Odisha Gramya Bank', label: 'Odisha Gramya Bank' },
  { value: 'Paschim Banga Gramin Bank', label: 'Paschim Banga Gramin Bank' },
  { value: 'Prathama U.P. Gramin Bank', label: 'Prathama U.P. Gramin Bank' },
  {
    value: 'Puduvai Bharathiar Grama Bank',
    label: 'Puduvai Bharathiar Grama Bank'
  },
  { value: 'Punjab Gramin Bank', label: 'Punjab Gramin Bank' },
  {
    value: 'Rajasthan Marudhara Gramin Bank',
    label: 'Rajasthan Marudhara Gramin Bank'
  },
  { value: 'Saptagiri Grameena Bank', label: 'Saptagiri Grameena Bank' },
  { value: 'Sarva Haryana Gramin Bank', label: 'Sarva Haryana Gramin Bank' },
  { value: 'Saurashtra Gramin Bank', label: 'Saurashtra Gramin Bank' },
  { value: 'Tamil Nadu Grama Bank', label: 'Tamil Nadu Grama Bank' },
  { value: 'Telangana Grameena Bank', label: 'Telangana Grameena Bank' },
  { value: 'Tripura Gramin Bank', label: 'Tripura Gramin Bank' },
  { value: 'Uttar Bihar Gramin Bank', label: 'Uttar Bihar Gramin Bank' },
  { value: 'Utkal Grameen Bank', label: 'Utkal Grameen Bank' },
  {
    value: 'Uttarbanga Kshetriya Gramin Bank',
    label: 'Uttarbanga Kshetriya Gramin Bank'
  },
  {
    value: 'Vidharbha Konkan Gramin Bank',
    label: 'Vidharbha Konkan Gramin Bank'
  },
  { value: 'Uttarakhand Gramin Bank', label: 'Uttarakhand Gramin Bank' },
  {
    value: 'The Nashik Road Deolali Vyapari Sahakari Bank Ltd',
    label: 'The Nashik Road Deolali Vyapari Sahakari Bank Ltd'
  },
  { value: 'Bhavani Shankar Bank', label: 'Bhavani Shankar Bank' },
  {
    value: 'THE PRATAP CO-OPERATIVE BANK LTD',
    label: 'THE PRATAP CO-OPERATIVE BANK LTD'
  },
  {
    value: 'STATE TRANSPORT CO-OP BANK LTD',
    label: 'STATE TRANSPORT CO-OP BANK LTD'
  },
  {
    value: 'KURLA NAGRIK SAHAKARI BANK LTD',
    label: 'KURLA NAGRIK SAHAKARI BANK LTD'
  },
  {
    value: 'THE CHEMBUR NAGRIK SAHAKARI BANK LTD',
    label: 'THE CHEMBUR NAGRIK SAHAKARI BANK LTD'
  },
  {
    value: 'Rajlaxmi Urban Co-operative Bank',
    label: 'Rajlaxmi Urban Co-operative Bank'
  },
  {
    value: 'Banaskantha Mercantile Co-operative Bank Ltd',
    label: 'Banaskantha Mercantile Co-operative Bank Ltd'
  },
  { value: 'Satara Sahakari Bank', label: 'Satara Sahakari Bank' },
  {
    value: 'Hindustan Co-operative Bank',
    label: 'Hindustan Co-operative Bank'
  },
  {
    value: 'Shri Arihant Co-operative Bank',
    label: 'Shri Arihant Co-operative Bank'
  },
  {
    value: 'Municipal Co-operative bank',
    label: 'Municipal Co-operative bank'
  },
  {
    value: 'Lokvikas Nagari Sahakari Bank',
    label: 'Lokvikas Nagari Sahakari Bank'
  },
  { value: 'Deogiri Sahakari Bank', label: 'Deogiri Sahakari Bank' },
  {
    value: 'The Vaidyanath Urban Co.Op Bank',
    label: 'The Vaidyanath Urban Co.Op Bank'
  },
  { value: 'Godavari Urban Co.Op Bank', label: 'Godavari Urban Co.Op Bank' },
  { value: 'Vishawas Co-OpBank', label: 'Vishawas Co-OpBank' },
  { value: 'APNA SAHAKARI BANK LTD', label: 'APNA SAHAKARI BANK LTD' },
  { value: 'THE JAIN SAHAKARI BANK', label: 'THE JAIN SAHAKARI BANK' },
  { value: 'State Bank of Travancore', label: 'State Bank of Travancore' },
  { value: 'Bank of Travancore', label: 'Bank of Travancore' },
  { value: 'THE NASHIK JILHA SAH BANK', label: 'THE NASHIK JILHA SAH BANK' },
  { value: 'SHREE MAHESH CO OP BANK', label: 'SHREE MAHESH CO OP BANK' },
  { value: 'SHRE SAMARTH SAH BANK LTD', label: 'SHRE SAMARTH SAH BANK LTD' },
  { value: 'SHALINI SAHAKARI BANK LTD', label: 'SHALINI SAHAKARI BANK LTD' },
  {
    value: 'PROGRESSIVE CO-OP BANK LTD',
    label: 'PROGRESSIVE CO-OP BANK LTD'
  },
  { value: 'JANASEVA SAHAKARI BANK', label: 'JANASEVA SAHAKARI BANK' },
  {
    value: 'Vaisai Janta Sahakari Bank',
    label: 'Vaisai Janta Sahakari Bank'
  },
  { value: 'DENA BANK', label: 'DENA BANK' },
  { value: 'Corporation Bank', label: 'Corporation Bank' },
  {
    value: 'Loknete dattaji patil sahakari bank',
    label: 'Loknete dattaji patil sahakari bank'
  },
  { value: 'Godavari co.op bank', label: 'Godavari co.op bank' },
  { value: 'Vishwas co.op bank', label: 'Vishwas co.op bank' },
  {
    value: 'The kalyan janta sahakari bank',
    label: 'The kalyan janta sahakari bank'
  },
  {
    value: 'The National Co-operative Bank ltd.',
    label: 'The National Co-operative Bank ltd.'
  },
  {
    value: 'THE BHUJ MERCANTILE CO-OP BANK LTD',
    label: 'THE BHUJ MERCANTILE CO-OP BANK LTD'
  },
  { value: 'Vaishya Sahakari Bank LTD', label: 'Vaishya Sahakari Bank LTD' },
  {
    value: 'VYAPARI SAHAKARI BANK MARYADIT',
    label: 'VYAPARI SAHAKARI BANK MARYADIT'
  },
  { value: 'Business Bank', label: 'Business Bank' },
  {
    value: 'MODEL CO-OPERATIVE BANK LTD',
    label: 'MODEL CO-OPERATIVE BANK LTD'
  },
  {
    value: 'The Pimpalgaon Merchant Co-op Bank Ltd.',
    label: 'The Pimpalgaon Merchant Co-op Bank Ltd.'
  },
  {
    value: 'Ashokanagar Co-operative Bank Ltd',
    label: 'Ashokanagar Co-operative Bank Ltd'
  },
  {
    value: 'THE MUMBAI MAHANAGARPALIKA SHIKSHAN VIBHAG SAHAKARI BANK LTD.',
    label: 'THE MUMBAI MAHANAGARPALIKA SHIKSHAN VIBHAG SAHAKARI BANK LTD.'
  },
  {
    value: 'The Aurangabad District Central Co-Operative Bank',
    label: 'The Aurangabad District Central Co-Operative Bank'
  },
  {
    value: 'Shri Chhatrapati Rajarshi Shahu Urban Cooperative Bank Limited',
    label: 'Shri Chhatrapati Rajarshi Shahu Urban Cooperative Bank Limited'
  },
  {
    value: 'The Municipal Co-op. Bank Ltd., Mumbai',
    label: 'The Municipal Co-op. Bank Ltd., Mumbai'
  },
  {
    value: 'The Thane Dist. Central Co Op. Bank Ltd',
    label: 'The Thane Dist. Central Co Op. Bank Ltd'
  },
  {
    value: 'Vasai Vikas Sahakari Bank Limited',
    label: 'Vasai Vikas Sahakari Bank Limited'
  },
  {
    value: 'The Muslim Co-operative Bank Ltd. branch - Pune',
    label: 'The Muslim Co-operative Bank Ltd. branch - Pune'
  },
  {
    value: 'Sreenidhi Souharda Sahakari Bank Niyamitha',
    label: 'Sreenidhi Souharda Sahakari Bank Niyamitha'
  },
  {
    value: 'The Chikhli Urban Co-op. Bank Ltd.',
    label: 'The Chikhli Urban Co-op. Bank Ltd.'
  },
  {
    value: 'The Sahyadri Sahakari Bank Ltd.',
    label: 'The Sahyadri Sahakari Bank Ltd.'
  }
];
